

import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postProductType = (
    token: string,
    backend: string,
    created_by_id: number,
    changed_by_id: number,
    name: string,
    description: string,
) => {
    return fetch(
        `${getApiUrl(backend)}producttypes`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                created_by_id,
                changed_by_id,
                name,
                description,
            })
        }
    );
};

export default postProductType;
